import React, { useState, useRef, useEffect, useContext } from "react";
import Footer11 from "../shared/Footer11";
import Navbar11 from "../shared/Navbar11";
import Sidebar11 from "../shared/Sidebar11";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { ContextBoard } from "../../context/ContextBoard";
import Swal from "sweetalert2";

function Addexregular11() {
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState("");
  const [yearList, setYearList] = useState([]);
  const navigate = useNavigate();

  const { setClass11exregulartudent } = useContext(ContextBoard);

  const [regType, setRegType] = useState("");

  const [reg1, setReg1] = useState("");
  const [reg2, setReg2] = useState("");
  const [reg3, setReg3] = useState("");

  const reg1Ref = useRef();
  const reg2Ref = useRef();
  const reg3Ref = useRef();

  const handleInput =
    (setter, maxLength, nextRef, prevRef = null) =>
      (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setter(value);
        if (value.length === parseInt(maxLength) && nextRef?.current) {
          nextRef.current.focus();
        }
        if (
          value.length === 0 &&
          prevRef?.current &&
          e.nativeEvent.inputType === "deleteContentBackward"
        ) {
          prevRef.current.focus();
        }
      };
  const handleSubmit = async () => {
    const fullReg = `${reg1}-${regType}-${reg2}-${reg3}`;
    if (!year) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Registration Session is missing",
      });
      return;
    }
    if (!reg1 || !regType || !reg2 || !reg3) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Registration Number is missing",
      });
      return;
    }


    try {
      setLoading(true);
      const token = sessionStorage.getItem("tokenclassxi");
      const response = await fetch(
        `${config.API_BASE_URL}/FetchDataEXRegularStudent_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            sessioN_CODE: year,
            registratioN_NO: fullReg,
          }),
        }
      );

      const result = await response.json();

      if (response.ok && result?.data) {
        setClass11exregulartudent(result.data.exRegularStudentCL9_data);
        setLoading(false);
        navigate("/class-xi-add-ex-regular-info-jac");
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.message || "Failed to fetch student data.",
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error submitting student data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
      });
    }
  };
  useEffect(() => {
    const fetchYears = async () => {
      try {
        setLoading(true);
        const token = sessionStorage.getItem("tokenclassxi");

        const response = await fetch(
          `${config.API_BASE_URL}/PageloadRegistrationSessionEXRegular_CL11`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setLoading(false);
        const data = await response.json();

        // Extracting the year from nested response
        const examYears = data?.data?.sessionExRegular_data?.sessionlist;
        setYearList(examYears);
        // if (Array.isArray(examYears) && examYears.length > 0) {
        //   setYearList(examYears.map((item) => item.year).sort((a, b) => b - a));
        // }
      } catch (error) {
        console.error("Failed to fetch year list:", error);
      }
    };

    fetchYears();
  }, []);
  return (
    <>
      <div class="container-scroller">
        <Navbar11 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar11 />
          {loading && (
            <div className="custom-loader-container">
              <div className="custom-loader"></div>
            </div>
          )}
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header ">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Add Ex-Regular
                      Student (Student Registration Page for Board Examination)
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-xi-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Add Student (JAC)</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Registration Details</h4>
                    </div>
                    <div class="card-body">
                      <div
                        class="row d-flex"
                        style={{ justifyContent: "center" }}
                      >
                        <div class="col-md-10 py-3">
                          <div class="row">
                            <label class="col-md-3">
                              Registration Session :
                            </label>
                            <div class="col-md-8">
                              <select
                                className="form-select form-select-xs"
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                              >
                                <option value="">Select</option>
                                {yearList.map((yr, idx) => (
                                  <option key={idx} value={yr.sessioN_CODE}>
                                    {yr.sessioN_FULL_NAME}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div class="row mt-3">
                            <label class="col-md-3">
                              Registration Number :
                            </label>
                            <div class="col-md-2">
                              <input
                                className="form-control form-control-xs"
                                value={reg1}
                                ref={reg1Ref}
                                maxLength="5"
                                onChange={handleInput(setReg1, 5, reg2Ref)}
                              />

                              <p>5 Digits Only</p>
                            </div>
                            <div class="col-md-2">
                              <select
                                id="registration_number4"
                                name="registration_number4"
                                className="form-control form-select form-control-xs"
                                value={regType}
                                onChange={(e) => setRegType(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="RS">RS</option>
                                <option value="RC">RC</option>
                                <option value="RA">RA</option>
                                <option value="PC">PC</option>
                                <option value="PA">PA</option>
                              </select>

                              {/* <p>2 Digits Only</p> */}
                            </div>
                            <div class="col-md-2">
                              <input
                                className="form-control form-control-xs"
                                value={reg2}
                                ref={reg2Ref}
                                maxLength="4"
                                onChange={handleInput(
                                  setReg2,
                                  4,
                                  reg3Ref,
                                  reg1Ref
                                )}
                              />
                              <p>4 Digits Only</p>
                            </div>
                            <div class="col-md-2">
                              <input
                                className="form-control form-control-xs"
                                value={reg3}
                                ref={reg3Ref}
                                maxLength="2"
                                onChange={handleInput(
                                  setReg3,
                                  2,
                                  null,
                                  reg2Ref
                                )}
                              />
                              <p>2 Digits Only</p>
                            </div>
                          </div>
                          <div class="row mt-3">
                            <div class="col-md-3"></div>
                            <div class="col-md-offset-3 col-md-8">
                              <div class="row">
                                <div class="col-md-2"></div>
                                <div class="col-md-8">
                                  <button
                                    type="submit"
                                    // onClick={() => {
                                    //   navigate(
                                    //     "/class-xi-add-ex-regular-info-jac"
                                    //   );
                                    // }}
                                    onClick={handleSubmit}
                                    class="btn btn-block btn-xs proceed-btn"
                                    style={{
                                      fontSize: "16px",
                                      padding: "8px",
                                      backgroundColor: "#FF0000",
                                      color: "white",
                                      fontWeight: "600",
                                    }}
                                    id="validate"
                                  >
                                    CLICK HERE TO VALIDATE &amp; PROCEED
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer11 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Addexregular11;
